import {
    FETCH_MERCHANT_LEGAL_ENTITY_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS,
    CREATE_MERCHANT_LEGAL_ENTITY_REQUEST,
    CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS,
    CREATE_MERCHANT_LEGAL_ENTITY_FAILURE,
    EDIT_MERCHANT_LEGAL_ENTITY_REQUEST,
    EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS,
    EDIT_MERCHANT_LEGAL_ENTITY_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS,
    MERCHANT_LEGAL_ENTITY_FORM_RESET,
    SET_STATIC_MERCHANT_LEGAL_ENTITY,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS,
    FETCH_BASIC_FORM_DATA_PROCESS_V1,
    FETCH_BASIC_FORM_DATA_SUCCESS_V1,
    FETCH_BASIC_FORM_DATA_FAILURE_V1,
    SAVE_AND_CONTINUE_REQUEST_V1,
    SAVE_AND_CONTINUE_SUCCESS_V1,
    SAVE_AND_CONTINUE_FAILED_V1,
    RESET_SUCCESS_KEY,
    RESET_FORM_DATA_MLE,
    FETCH_MLE_FORM_IN_PROCESS_REQUEST,
    FETCH_MLE_FORM_IN_PROCESS_SUCCESS,
    FETCH_MLE_FORM_IN_PROCESS_ERROR,
    SUBMIT_REQUEST_DATA_MLE,
    SUBMIT_SUCCESS_DATA_MLE,
    SUBMIT_FAILURE_DATA_MLE,
    REDIRECT_KEY_MLE,
    CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS,
} from './merchantLegalEntity.constants';

export const fetchMerchantLegalEntityRequest = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_REQUEST,
    payload,
});

export const fetchMerchantLegalEntitySuccess = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS,
    payload,
});

export const fetchMerchantLegalEntityFailure = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_FAILURE,
    payload,
});

export const createMerchantLegalEntityRequest = payload => ({
    type: CREATE_MERCHANT_LEGAL_ENTITY_REQUEST,
    payload,
});

export const createMerchantLegalEntitySuccess = payload => ({
    type: CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS,
    payload,
});

export const createMerchantLegalEntityFailure = payload => ({
    type: CREATE_MERCHANT_LEGAL_ENTITY_FAILURE,
    payload,
});

export const fetchMerchantLegalEntityDetailsRequest = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST,
    payload,
});

export const fetchMerchantLegalEntityDetailsSuccess = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS,
    payload,
});

export const fetchMerchantLegalEntityDetailsFailure = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE,
    payload,
});

export const clearMerchantLegalEntityDetails = () => ({
    type: CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS,
});

export const fetchMerchantLegalEntityDetailsPincodeRequest = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST,
    payload,
});

export const fetchMerchantLegalEntityDetailsPincodeSuccess = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS,
    payload,
});

export const fetchMerchantLegalEntityDetailsPincodeFailure = payload => ({
    type: FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE,
    payload,
});




export const editMerchantLegalEntityRequest = payload => ({
    type: EDIT_MERCHANT_LEGAL_ENTITY_REQUEST,
    payload,
});

export const editMerchantLegalEntitySuccess = payload => ({
    type: EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS,
    payload,
});

export const editMerchantLegalEntityFailure = payload => ({
    type: EDIT_MERCHANT_LEGAL_ENTITY_FAILURE,
    payload,
});

export const resetMerchantLegalEntityFormReset = payload => ({
    type: MERCHANT_LEGAL_ENTITY_FORM_RESET,
    payload,
});

export const setStaticMerchantLegalEntity = payload => ({
    type: SET_STATIC_MERCHANT_LEGAL_ENTITY,
    payload
})

export const fetchBasicFormDataProcess = payload => ({
    type: FETCH_BASIC_FORM_DATA_PROCESS_V1,
    payload
})

export const fetchBasicFormDataSuccess = payload => ({
    type: FETCH_BASIC_FORM_DATA_SUCCESS_V1,
    payload
})

export const fetchBasicFormDataFailure = payload => ({
    type: FETCH_BASIC_FORM_DATA_FAILURE_V1,
    payload
})

export const saveAndContinueRequestV1 = payload => ({
    type: SAVE_AND_CONTINUE_REQUEST_V1,
    payload
});

export const saveAndContinueSuccessV1 = (payload, sectionType) => ({
    type: SAVE_AND_CONTINUE_SUCCESS_V1,
    payload,
    sectionType
});

export const saveAndContinueFailedV1 = payload => ({
    type: SAVE_AND_CONTINUE_FAILED_V1,
    payload
});

export const resetSuccessKey = (payload) => ({
    type: RESET_SUCCESS_KEY,
    payload
})

export const resetFormDataMLE = (payload) => ({
    type: RESET_FORM_DATA_MLE,
    payload
})

export const fetchMLEFormInProcessRequest = () => ({
    type: FETCH_MLE_FORM_IN_PROCESS_REQUEST,
});

export const fetchMLEFormInProcessSuccess = payload => ({
    type: FETCH_MLE_FORM_IN_PROCESS_SUCCESS,
    payload,
});

export const fetchMLEFormInProcessError = payload => ({
    type: FETCH_MLE_FORM_IN_PROCESS_ERROR,
    payload,
});

export const submitRequestCallMle = payload => ({
    type: SUBMIT_REQUEST_DATA_MLE,
    payload
})

export const submitSuccessMLE = payload => ({
    type: SUBMIT_SUCCESS_DATA_MLE,
    payload
})

export const submitFailureMle = payload => ({
    type: SUBMIT_FAILURE_DATA_MLE,
    payload
})

export const removeRedirectKey = () => ({
    type: REDIRECT_KEY_MLE,
})
